<template>
  <header class="v-align" :class="itemsPosition">
    <!-- <b-container fluid> -->
    <div v-if="context !== 'formation'" class="header-content">
      <b-col class="brand-section" :class="[!isUnlogged ? 'col-12':'col-12 justify-content-center']">
          <template v-if="logo">
            <b-col cols="4" class="company-logo">
              <img :src="logo" alt="logo"/>
            </b-col>

            <b-col cols="8" class="p-0 text-center logo">
              <img src="@/assets/img/bba/logo.png" alt="bba_logo" />
            </b-col>

            <b-col cols="8" offset="4" class="text-center slogan">
              {{ $t('bba.slogan') }}
            </b-col>
          </template>

          <template v-else>
            <b-col cols="12" class="p-0 text-center logo">
              <img src="@/assets/img/bba/logo.png" alt="bba_logo" />
            </b-col>

            <b-col cols="12" class="p-0 text-center slogan">
              {{ $t('bba.slogan') }}
            </b-col>
          </template>
      </b-col>

      <!-- <b-col v-if="!isUnlogged" cols="3" order="2" class="bg-menu">
        <menu-button id="btn-menu" />
      </b-col> -->
    </div>
    <div v-else class="container header-content">
      <div class="d-flex justify-content-between">
        <span class="p-3">
          <router-link :to="{name: 'formation'}">
            <i class="fas fa-arrow-alt-circle-left"></i>
            <span class="back-home">Accueil</span>
          </router-link>
        </span>
        <div>
          <b-col cols="12" class="p-0 text-center logo">
            <img src="@/assets/img/bba/logo.png" alt="bba_logo" />
          </b-col>

          <b-col cols="12" class="p-0 text-center slogan">
            {{ $t('bba.slogan') }}
          </b-col>
        </div>
      </div>
    </div>
    <!-- </b-container> -->
  </header>
</template>

<script>
import { flexbox } from '@/utils/style'
import menuButton from '@/components/frontoffice/button/menu'

export default {
  components: {
    menuButton
  },

  props: [ 'logo' ],

  data () {
    return {
      currentPage: this.$route.name,
      isUnlogged: this.$route.name === 'offline_booking_prelogged_company' || this.$route.name === 'offline_booking_generic_company' || this.$route.name === 'home_generic_company',
      context: this.$store.getters['research/context']
    }
  },

  computed: {
    itemsPosition () {
      return flexbox.position.justifyContent('middle')
    }
  }
}
</script>
